/**
 * Structure of the pre-job check form (based on PREPOST JOB Check.xlsx).
 * Keys mirror what will be stored in the `data` dict in the pjc document.
 */
export const PJC_STRUCTURE = [
  {
    id: "general",
    title: "Información general",
    fields: [
      { key: "empresa_contratista", label: "Empresa contratista", type: "text", placeholder: "Suntelco / Sunfrica / …" },
      { key: "direccion", label: "Dirección", type: "text", placeholder: "Calle, número, localidad" },
      { key: "instalacion", label: "Instalación", type: "text", placeholder: "Nombre de la instalación" },
      { key: "instalacion_nueva", label: "Instalación nueva", type: "boolean" },
      { key: "fecha", label: "Fecha", type: "date" },
      { key: "hora", label: "Hora", type: "time" },
    ],
  },
  {
    id: "riesgos_instalacion",
    title: "Identificación de riesgos en la instalación",
    hint: "Riesgos existentes en el entorno donde se ejecutan los trabajos.",
    fields: [
      { key: "riesgo_electrico_inst", label: "Trabajo con riesgo eléctrico", type: "check" },
      { key: "maquinaria_no_ce_inst", label: "Maquinaria sin marcado CE", type: "check" },
      { key: "altura_inst", label: "Trabajo en altura", type: "check" },
      { key: "polvo_inst", label: "Elevada concentración de polvo", type: "check" },
      { key: "otros_riesgos_inst", label: "Otros riesgos", type: "textarea" },
    ],
  },
  {
    id: "seguridad",
    title: "Evaluación de seguridad",
    fields: [
      { key: "entorno_seguro", label: "¿El entorno es aparentemente seguro para ejecutar los trabajos?", type: "yesno", required: true },
      { key: "capacidad_control", label: "Si NO: ¿tiene capacidad para controlar el riesgo?", type: "yesno", showIf: { key: "entorno_seguro", equals: "NO" } },
    ],
  },
  {
    id: "epis",
    title: "Equipos de protección individual (EPIs)",
    warning: "No se deben comenzar los trabajos si alguna de las respuestas es NO.",
    fields: [
      { key: "epis_disponibles", label: "Dispone de todos los EPIs necesarios según normativa y protocolo", type: "yesno", required: true },
      { key: "epis_estado", label: "Los EPIs están en buen estado, sin caducar y sus compañeros disponen de ellos", type: "yesno", required: true },
    ],
  },
  {
    id: "riesgos_trabajo",
    title: "Riesgos previstos durante el trabajo",
    fields: [
      { key: "riesgo_electrico_trab", label: "Trabajo con riesgo eléctrico", type: "check" },
      { key: "maquinaria_no_ce_trab", label: "Maquinaria sin marcado CE", type: "check" },
      { key: "altura_trab", label: "Trabajo en altura", type: "check" },
      { key: "polvo_trab", label: "Elevada concentración de polvo", type: "check" },
      { key: "otros_riesgos_trab", label: "Otros riesgos", type: "textarea" },
    ],
  },
  {
    id: "formacion",
    title: "Formación técnica y PRL",
    fields: [
      { key: "formacion_prl", label: "¿Están usted y sus compañeros formados en PRL para la labor a realizar?", type: "yesno", required: true },
    ],
  },
  {
    id: "plan",
    title: "Plan de ejecución",
    fields: [
      { key: "como_trabajos", label: "¿Cómo se van a realizar los trabajos?", type: "textarea", placeholder: "Describe brevemente el método de trabajo" },
      { key: "plan_prevencion", label: "De acuerdo con el Plan Específico de Prevención / Plan de Seguridad y Salud", type: "yesno" },
      { key: "plan_ambiental", label: "De acuerdo con el Plan Ambiental / Plan de gestión de residuos", type: "yesno" },
      { key: "procedimientos", label: "Procedimientos aplicables (indicar cuáles)", type: "textarea" },
      { key: "otros_plan", label: "Otros (reunión de coordinación, descargo nº, etc.)", type: "textarea" },
    ],
  },
  {
    id: "equipo",
    title: "Integrantes del equipo de trabajo",
    hint: "Lista los nombres de los integrantes del equipo. Su firma indica aceptación de los nombramientos.",
    fields: [
      { key: "integrantes", label: "Nombres y apellidos", type: "textarea", placeholder: "Un nombre por línea" },
    ],
  },
];

export const DEFAULT_PJC_DATA = () => {
  const now = new Date();
  const dateStr = now.toISOString().slice(0, 10);
  const timeStr = now.toTimeString().slice(0, 5);
  return { fecha: dateStr, hora: timeStr };
};
